import _objectSpread from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-47df29e1"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "content-container"
};
var _hoisted_2 = {
  key: 0
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "数据资产审批人", -1);
});

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "grey mt5"
  }, [/*#__PURE__*/_createTextVNode(" 为避免将权限申请的通知推送到全部管理员，对管理员造成集中的审批压力，现支持从空间管理员中挑选专门的数据资产审批人，负责审批本空间内对数据资产权限的申请；除审批人以外的空间管理员不会收到申请审批待办。"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode("审批流默认为一级审批，支持在单个数据资产的授权面板，自定义二级审批人。 ")], -1);
});

var _hoisted_5 = {
  key: 0,
  class: "mt20"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  class: "ml10"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "blank0"
  }, null, -1);
});

var _hoisted_9 = /*#__PURE__*/_createTextVNode("编 辑");

var _hoisted_10 = {
  key: 1,
  class: "mt20"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "blank0"
  }, null, -1);
});

var _hoisted_12 = /*#__PURE__*/_createTextVNode("编 辑");

var _hoisted_13 = {
  key: 2
};
var _hoisted_14 = {
  class: "mt20"
};
var _hoisted_15 = {
  class: "mt20"
};

var _hoisted_16 = /*#__PURE__*/_createTextVNode("保 存");

var _hoisted_17 = /*#__PURE__*/_createTextVNode("取 消");

var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "空间审批人", -1);
});

var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "grey mt5"
  }, [/*#__PURE__*/_createTextVNode(" 空间审批人用于空间加入申请，及数据资产权限审批人因离职等情况失去审批权力时，最终的权限管理者。"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 请从空间管理员角色组中挑选空间审批人，负责审批对空间权限的申请。审批流默认为一级审批，可支持配置二级审批。一级审批人默认为空间创建者。 ")], -1);
});

var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "mt10 mb10 grey"
  }, "一级审批人：", -1);
});

var _hoisted_21 = {
  key: 0
};
var _hoisted_22 = ["src"];
var _hoisted_23 = {
  class: "ml10"
};

var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "blank0"
  }, null, -1);
});

var _hoisted_25 = {
  key: 1
};

var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "mt10 mb10 grey"
  }, "二级审批人：", -1);
});

var _hoisted_27 = {
  key: 2
};
var _hoisted_28 = ["src"];
var _hoisted_29 = {
  class: "ml10"
};
var _hoisted_30 = {
  key: 1
};

var _hoisted_31 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "blank0"
  }, null, -1);
});

var _hoisted_32 = {
  key: 3
};

var _hoisted_33 = /*#__PURE__*/_createTextVNode("取 消");

import authWrap from './components/authWrap';
import DtMessage from '@/components/DtMessage';
import { isEmpty, get } from 'lodash';
import { ref, computed, watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import AuthService from '@/api/auth';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var route = useRoute();
    var store = useStore();
    var pageTitle = ref('权限审批流程设置');
    var loading = ref(true); // 数据资产审批人备选列表

    var bizAdminList = ref([]); // 数据资产 查看/编辑 状态

    var showDataApprover = ref(true); // 空间审批 查看/编辑 状态

    var showBizApprover = ref(true); // 待添加的审批人列表

    var dataApprovers = ref([]);
    var dataApproverList = ref([]); // 空间一级审批人列表

    var bizFirstApproversList = ref([]); // 空间一级审批人列表（包含头像信息）

    var bizFirstApproverInfo = ref([]); // 空间二级审批人列表

    var bizSecondApproversList = ref([]); // 空间二级审批人列表（包含头像信息）

    var bizSecondApproverInfo = ref([]);
    var tabActiveName = ref('data');
    var disableSelect = ref(false);
    var ADMIN_GROUP_ID = ref('BIZ_ADMIN_ROLE');
    var isAdmin = computed(function () {
      return store.state.user.userDetail.isAdmin;
    });
    var searchParams = computed(function () {
      return {
        appKey: route.params.project
      };
    });
    var bizId = computed(function () {
      return route.params.biz_url;
    });
    var baseParams = computed(function () {
      return {
        bizId: bizId.value,
        appKey: route.params.project
      };
    }); // methods
    // 获取空间审批流数据

    var getBizInfo = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data, response, firstInvalidMessage, secondInvalidMessage;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return AuthService.getBizApprover(baseParams.value);

              case 2:
                data = _context.sent;

                if ((data === null || data === void 0 ? void 0 : data.data.code) === 1) {
                  response = data.data.result;
                  bizFirstApproverInfo.value = get(response, 'first_approvers', []);
                  bizSecondApproverInfo.value = get(response, 'second_approvers', []);
                  bizFirstApproversList.value = bizFirstApproverInfo.value.map(function (item) {
                    return item.name;
                  });
                  bizSecondApproversList.value = bizSecondApproverInfo.value.map(function (item) {
                    return item.name;
                  }); // 如果有失效的审批人，则弹窗提醒

                  firstInvalidMessage = get(response, 'first_invalid_message', null);
                  secondInvalidMessage = get(response, 'second_invalid_message', null); // 失效审批人，弹窗提醒

                  if (firstInvalidMessage !== null) {
                    DtMessage({
                      type: 'warning',
                      message: firstInvalidMessage
                    });
                  }

                  if (secondInvalidMessage !== null) {
                    DtMessage({
                      type: 'warning',
                      message: secondInvalidMessage
                    });
                  }
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getBizInfo() {
        return _ref.apply(this, arguments);
      };
    }(); // 获取数据审批人列表


    var getDataAssetsApprover = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _data$data;

        var params, data, _res$first_approver, res, firstApproverList;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loading.value = true;
                disableSelect.value = false;
                params = _objectSpread({
                  category: 'DATA_COMMON'
                }, baseParams.value);
                _context2.next = 5;
                return AuthService.getAssetApprover(params);

              case 5:
                data = _context2.sent;
                loading.value = false;

                if (!(((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1)) {
                  _context2.next = 17;
                  break;
                }

                res = data.data.result;
                dataApproverList.value = [];

                if (!(isEmpty(res) || res.first_approver === '')) {
                  _context2.next = 13;
                  break;
                }

                disableSelect.value = true;
                return _context2.abrupt("return");

              case 13:
                firstApproverList = (_res$first_approver = res.first_approver) === null || _res$first_approver === void 0 ? void 0 : _res$first_approver.split(',');
                bizAdminList.value.forEach(function (admin) {
                  firstApproverList.forEach(function (approver) {
                    if (admin.name === approver || admin.login_name === approver) {
                      dataApproverList.value.push(admin);
                    }
                  });
                });
                _context2.next = 18;
                break;

              case 17:
                disableSelect.value = true;

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getDataAssetsApprover() {
        return _ref2.apply(this, arguments);
      };
    }(); // 获取备选数据资产审批人列表（空间管理员列表）


    var getBizAdminList = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _data$data2;

        var params, data, result;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                loading.value = true;
                params = _objectSpread({
                  memberFlag: true,
                  filterQuitUser: true
                }, baseParams.value); // 获取空间角色列表

                _context3.next = 4;
                return AuthService.getRoleAdminList(params);

              case 4:
                data = _context3.sent;
                loading.value = false;

                if (((_data$data2 = data.data) === null || _data$data2 === void 0 ? void 0 : _data$data2.code) === 1) {
                  result = data.data.result;
                  bizAdminList.value = get(result[0], 'member_list') || []; // 获取数据资源审批人列表

                  getDataAssetsApprover();
                  getBizInfo();
                }

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function getBizAdminList() {
        return _ref3.apply(this, arguments);
      };
    }();

    var handleDateApproverModify = function handleDateApproverModify() {
      disableSelect.value = false;
      showDataApprover.value = false;
      dataApprovers.value = dataApproverList.value.map(function (item) {
        return item.name;
      });
    }; // 保存数据资产审批人信息


    var saveDataApprover = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _data$data3;

        var approver, params, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(dataApprovers.value.length > 50)) {
                  _context4.next = 3;
                  break;
                }

                DtMessage({
                  type: 'warning',
                  message: '数据资产审批人，最多只能选择50位审批人。'
                });
                return _context4.abrupt("return");

              case 3:
                loading.value = true;
                approver = dataApprovers.value.join(',');
                params = _objectSpread({
                  dataId: 'DATA_COMMON',
                  category: 'DATA_COMMON',
                  firstApprover: approver
                }, baseParams.value); // TODO  showMsg: true,

                _context4.next = 8;
                return AuthService.updateAssetApprover(params);

              case 8:
                data = _context4.sent;
                loading.value = false;

                if (((_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : _data$data3.code) === 1) {
                  DtMessage({
                    type: 'success',
                    message: '操作成功'
                  });
                  dataApprovers.value = [];
                  showDataApprover.value = true;
                  getDataAssetsApprover();
                }

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function saveDataApprover() {
        return _ref4.apply(this, arguments);
      };
    }(); // 保存空间审批人


    var saveBizApprover = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _data$data4;

        var params, data, _data$data5;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!showBizApprover.value) {
                  _context5.next = 3;
                  break;
                }

                showBizApprover.value = false;
                return _context5.abrupt("return");

              case 3:
                if (!(bizFirstApproversList.value.length === 0)) {
                  _context5.next = 6;
                  break;
                }

                DtMessage({
                  type: 'warning',
                  message: '空间的一级审批人不可为空，请选择一级审批人'
                });
                return _context5.abrupt("return");

              case 6:
                if (!(bizFirstApproversList.value.toString() === bizSecondApproversList.value.toString())) {
                  _context5.next = 9;
                  break;
                }

                DtMessage({
                  type: 'warning',
                  message: '空间的一级审批人和二级审批人，不可相同'
                });
                return _context5.abrupt("return");

              case 9:
                loading.value = true;
                params = _objectSpread({
                  category: 'BIZ',
                  firstApprover: bizFirstApproversList.value.join(','),
                  secondApprover: bizSecondApproversList.value.join(',')
                }, baseParams.value);
                _context5.next = 13;
                return AuthService.updateBizApprover(params);

              case 13:
                data = _context5.sent;
                loading.value = false;

                if (((_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : _data$data4.code) === 1) {
                  DtMessage({
                    type: 'success',
                    message: '操作成功'
                  });
                  getBizInfo();
                  showBizApprover.value = true;
                  bizFirstApproversList.value = [];
                  bizSecondApproversList.value = [];
                } else {
                  DtMessage({
                    type: 'error',
                    message: (_data$data5 = data.data) === null || _data$data5 === void 0 ? void 0 : _data$data5.msg
                  });
                }

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function saveBizApprover() {
        return _ref5.apply(this, arguments);
      };
    }();

    var cancelDataApprover = function cancelDataApprover() {
      // 如果审批人有值，则回显，没有则 disable select
      if (dataApproverList.value.length === 0) {
        disableSelect.value = true;
        showDataApprover.value = true;
      } else {
        showDataApprover.value = true;
        dataApprovers.value = [];
      }
    };

    var cancelBizApprover = function cancelBizApprover() {
      showBizApprover.value = true;
    };

    onMounted(function () {
      getBizAdminList();
    });
    watch([function () {
      return route.params.biz_url;
    }, function () {
      return route.params.project;
    }], /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(newval, oldval) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                getBizAdminList();

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x, _x2) {
        return _ref6.apply(this, arguments);
      };
    }());
    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");

      var _component_el_option = _resolveComponent("el-option");

      var _component_el_select = _resolveComponent("el-select");

      var _component_el_tab_pane = _resolveComponent("el-tab-pane");

      var _component_el_tabs = _resolveComponent("el-tabs");

      var _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createBlock(_unref(authWrap), {
        "search-params": _unref(searchParams)
      }, {
        default: _withCtx(function () {
          return [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [!_unref(isAdmin) ? (_openBlock(), _createElementBlock("div", _hoisted_2, "你不是该空间的管理员，没有权限审批流程设置的权限")) : (_openBlock(), _createBlock(_component_el_tabs, {
            key: 1,
            modelValue: tabActiveName.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
              return tabActiveName.value = $event;
            }),
            tabPosition: "left",
            style: {
              "height": "100vh"
            }
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_el_tab_pane, {
                label: "数据资产审批",
                name: "data"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_3, _hoisted_4, showDataApprover.value && !disableSelect.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataApproverList.value, function (item, index) {
                    return _openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "approver-item mb20 flex-v-center",
                      style: {
                        "float": "left"
                      }
                    }, [_createElementVNode("img", {
                      src: item.avatar ? item.avatar : "//dcloud.oa.com/Public/Avatar/".concat(item.login_name, ".png")
                    }, null, 8, _hoisted_6), _createElementVNode("p", _hoisted_7, _toDisplayString(item.name), 1)]);
                  }), 128)), _hoisted_8, _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: handleDateApproverModify
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_9];
                    }),
                    _: 1
                  })])) : showDataApprover.value && disableSelect.value ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_el_select, {
                    class: "w400",
                    modelValue: dataApprovers.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                      return dataApprovers.value = $event;
                    }),
                    disabled: "",
                    placeholder: "请在空间管理员中，选择成员自定义数据资产审批人"
                  }, {
                    default: _withCtx(function () {
                      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bizAdminList.value, function (item) {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: item.name,
                          label: item.name,
                          value: item.login_name
                        }, null, 8, ["label", "value"]);
                      }), 128))];
                    }),
                    _: 1
                  }, 8, ["modelValue"]), _hoisted_11, _createVNode(_component_el_button, {
                    class: "mt20",
                    type: "primary",
                    onClick: handleDateApproverModify
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_12];
                    }),
                    _: 1
                  })])) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_el_select, {
                    class: "w400",
                    modelValue: dataApprovers.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                      return dataApprovers.value = $event;
                    }),
                    multiple: "",
                    filterable: "",
                    "default-first-option": "",
                    placeholder: "请在空间管理员中，选择成员自定义数据资产审批人"
                  }, {
                    default: _withCtx(function () {
                      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bizAdminList.value, function (item) {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: item.name,
                          label: item.name,
                          value: item.login_name
                        }, null, 8, ["label", "value"]);
                      }), 128))];
                    }),
                    _: 1
                  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_button, {
                    type: "primary",
                    onClick: saveDataApprover
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_16];
                    }),
                    _: 1
                  }), _createVNode(_component_el_button, {
                    onClick: cancelDataApprover
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_17];
                    }),
                    _: 1
                  })])]))];
                }),
                _: 1
              }), _createVNode(_component_el_tab_pane, {
                label: "空间审批",
                name: "biz"
              }, {
                default: _withCtx(function () {
                  return [_hoisted_18, _hoisted_19, _createElementVNode("div", null, [_hoisted_20, showBizApprover.value ? (_openBlock(), _createElementBlock("div", _hoisted_21, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bizFirstApproverInfo.value, function (item) {
                    return _openBlock(), _createElementBlock("div", {
                      key: item.name,
                      class: "approver-item mb20 flex-v-center",
                      style: {
                        "float": "left"
                      }
                    }, [_createElementVNode("img", {
                      src: item.avatar ? item.avatar : "//dcloud.oa.com/Public/Avatar/".concat(item.loginName, ".png")
                    }, null, 8, _hoisted_22), _createElementVNode("p", _hoisted_23, _toDisplayString(item.name), 1)]);
                  }), 128)), _hoisted_24])) : (_openBlock(), _createElementBlock("div", _hoisted_25, [_createVNode(_component_el_select, {
                    class: "w400",
                    modelValue: bizFirstApproversList.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                      return bizFirstApproversList.value = $event;
                    }),
                    multiple: "",
                    filterable: "",
                    "default-first-option": "",
                    placeholder: "请选择审批人"
                  }, {
                    default: _withCtx(function () {
                      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bizAdminList.value, function (item) {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: item.name,
                          label: item.name,
                          value: item.login_name
                        }, null, 8, ["label", "value"]);
                      }), 128))];
                    }),
                    _: 1
                  }, 8, ["modelValue"])])), _hoisted_26, showBizApprover.value ? (_openBlock(), _createElementBlock("div", _hoisted_27, [bizSecondApproverInfo.value.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
                    key: 0
                  }, _renderList(bizSecondApproverInfo.value, function (item) {
                    return _openBlock(), _createElementBlock("div", {
                      key: item.name,
                      class: "approver-item mb20 flex-v-center",
                      style: {
                        "float": "left"
                      }
                    }, [_createElementVNode("img", {
                      src: item.avatar ? item.avatar : "//dcloud.oa.com/Public/Avatar/".concat(item.login_name, ".png")
                    }, null, 8, _hoisted_28), _createElementVNode("p", _hoisted_29, _toDisplayString(item.name), 1)]);
                  }), 128)) : (_openBlock(), _createElementBlock("p", _hoisted_30, "-")), _hoisted_31])) : (_openBlock(), _createElementBlock("div", _hoisted_32, [_createVNode(_component_el_select, {
                    class: "w400",
                    modelValue: bizSecondApproversList.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
                      return bizSecondApproversList.value = $event;
                    }),
                    multiple: "",
                    filterable: "",
                    "default-first-option": "",
                    placeholder: "请选择审批人"
                  }, {
                    default: _withCtx(function () {
                      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bizAdminList.value, function (item) {
                        return _openBlock(), _createBlock(_component_el_option, {
                          key: item.name,
                          label: item.name,
                          value: item.login_name
                        }, null, 8, ["label", "value"]);
                      }), 128))];
                    }),
                    _: 1
                  }, 8, ["modelValue"])]))]), _createVNode(_component_el_button, {
                    class: "mt20",
                    type: "primary",
                    onClick: saveBizApprover
                  }, {
                    default: _withCtx(function () {
                      return [_createTextVNode(_toDisplayString(showBizApprover.value ? '编 辑' : '保 存'), 1)];
                    }),
                    _: 1
                  }), _withDirectives(_createVNode(_component_el_button, {
                    class: "mt20",
                    onClick: cancelBizApprover
                  }, {
                    default: _withCtx(function () {
                      return [_hoisted_33];
                    }),
                    _: 1
                  }, 512), [[_vShow, !showBizApprover.value]])];
                }),
                _: 1
              })];
            }),
            _: 1
          }, 8, ["modelValue"]))])), [[_directive_loading, loading.value]])];
        }),
        _: 1
      }, 8, ["search-params"]);
    };
  }
});